export default {
  // system
  BASE_API_URL: process.env.VUE_APP_BASE_API_URL,
  API_KEY: 'dUd4QCRb49kUoFqxd337BPorPphXllHxknY2crt1XckrxXkxkcakgj4fgnmOHSxz',
  THEME_VERSION: process.env.VUE_APP_THEME,
  JWT_WORKER_CREDIT: 'cHJhdGFEaWdpdGFsMjAyNURlejI=',
  TOKEN_STORAGE_KEY: 'UHJhdGFBZG1pblRva2VuU3RvcmFnZTIwMjY=',

  // Worker Credit
  WORKER_CREDIT_WITHOUT_INSURANCE_MARGIN: 0.9,

  // suppliers
  SUPPLIER_ID_QITECH: 1,
  SUPPLIER_ID_BMP: 4,
  SUPPLIER_ID_CARTOS: 7,
  SUPPLIER_ID_BV: 17,
  SUPPLIER_ID_CELCOIN: 18,
  SUPPLIER_ID_BMS: 22,
  SUPPLIER_ID_PRATA_AUTO: 23,

  // Prata Auto
  PRATA_AUTO_ALLOWED_UFS: ['SP', 'PR', 'SC', 'MG'],

  // bank account :: normalized vocabulary, see utils/bankAccount
  BANK_ACCOUNT_TYPES_ALLOWED: ['POUPANCA', 'CORRENTE'],
  BANK_ACCOUNT_TYPE_PAYMENT: 'PAGAMENTO',

  // products
  PRODUCT_ID_FGTS: 3,
  PRODUCT_ID_CGV: 4,
  PRODUCT_ID_CREDIT_CARD: 8,
  PRODUCT_ID_INSS: 12,
  PRODUCT_ID_WORKER_CREDIT: 13,
  PRODUCT_ID_WORKER_CREDIT_ACTION: 14,

  DEPLOY_VERSION:1793826216,
};
